<template>

	<div class="member">
		<div class="tit">
		<h5>會員中心 </h5>	
		</div>
		<div class="con">
			<ul>
				<li>
					<h6>我的交易</h6>
					<router-link to="/user/orders">
						<p :class="{'act':title=='1'}"><span></span>訂單管理</p>
					</router-link>
					<router-link to="/user/gifts">
						<p :class="{'act':title=='9'}"><span></span>我的兌換</p>
					</router-link>
					<router-link to="/user/coll">
						<p :class="{'act':title=='2'}"><span></span> 我的收藏</p>
					</router-link>
				<router-link to="/user/address">
					<p :class="{'act':title=='3'}"><span></span>購物地址</p>
				</router-link>
				</li>
				
			</ul>
			<ul>
				<li>
					<h6>我的資產</h6>
					<router-link to="/user/gift">
					<p :class="{'act':title=='4'}"><span></span>積分</p>
					</router-link>
					<router-link to="/user/receive">
					<p :class="{'act':title=='8'}"><span></span>接收優惠券</p>
					</router-link>
					<router-link to="/user/coupon">
					<p :class="{'act':title=='5'}"><span></span>優惠券</p>
					</router-link>
				</li>
				
			</ul>
			<ul>
				<li>
					<h6>個人資料</h6>
				<router-link to="/user/info">	<p :class="{'act':title=='6'}"><span></span>基本情况 </p>	</router-link>
				<router-link to="/user/account">	<p :class="{'act':title=='7'}"><span></span>帳戶安全 </p></router-link>
				</li>
				
			</ul>
		</div>
	</div>
</template>
<script>


export default {
  props: {
	title:String,
  },
  methods: {
    getBarBtn(index) {
      this.barBtn = index;
    },
  },
};
</script>

<style lang='scss' scoped>
.member{
	font-size: 14px;
	width: 247px;
	height: 687px;
	background: #F8F8F8;
	padding: 30px;
	h5{
		line-height: 50px;
		font-size: 14px;
		background: url(../../assets/bot1.png) no-repeat bottom left;
	}
	.con{
		li{
			border-bottom:1px solid #eeeeee;
			padding: 20px;
		}
		h6{
			line-height: 40px;
			font-size: 14px;
		}
		p{
			display: flex;
			line-height: 40px;
			align-items: center;
			color: #777777;
			span{
				display: inline-block;
				width: 6px;
				height: 6px;
				background: #636363;
				border-radius: 50%;
				margin-right: 10px;
			}
		}
		.act{
			color: #000000;
		}
	}

}
</style>